webpackJsonp([220905330635604],{

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/traiteur.830abb9b.png";

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background: url(', ') no-repeat;\n'], ['\n  background: url(', ') no-repeat;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(77);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	__webpack_require__(411);
	
	var _Layout = __webpack_require__(23);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _traiteur = __webpack_require__(565);
	
	var _traiteur2 = _interopRequireDefault(_traiteur);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Image = _styledComponents2.default.div(_templateObject, _traiteur2.default);
	
	var Caterer = function Caterer(_ref) {
	  var locale = _ref.pathContext.locale;
	
	  return _react2.default.createElement(
	    _Layout2.default,
	    { locale: locale },
	    _react2.default.createElement(
	      'div',
	      { className: 'row no-gutters caterer' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-12 col-lg-5 col-xl-4 pr-0 pr-lg-5' },
	        _react2.default.createElement(
	          'h5',
	          { className: 'text-uppercase title' },
	          'Banoi sur mesure'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'courier-new text' },
	          'Rafra\xEEchissantes et originales, nos recettes sont id\xE9ales pour composer un buffet.'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'courier-new text' },
	          'Des bouch\xE9es de rouleaux de printemps aux tartinettes de Banh-Mi en passant par des verrines de panna cocotta, Banoi ravira vos convives.'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'courier-new text' },
	          'Habitu\xE9s aux \xE9v\xE9nements professionnels, culturels ou priv\xE9s comme un mariage, faites-nous part de votre projet et nous composerons ensemble le menu adapt\xE9 \xE0 vos envies.'
	        ),
	        _react2.default.createElement(
	          'u',
	          null,
	          _react2.default.createElement(
	            'a',
	            { className: 'courier-new text', href: 'mailto:contact@banoi.fr' },
	            'Racontez-nous votre projet'
	          )
	        )
	      ),
	      _react2.default.createElement(Image, { className: 'col-12 col-lg-7 col-xl-8 mt-4 mt-sm-0 img-right' })
	    )
	  );
	};
	
	exports.default = Caterer;
	module.exports = exports['default'];

/***/ }),

/***/ 411:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-caterer-js-7cdee30bcd66f302ad0c.js